module.exports = __webpack_public_path__ + "img/profile-icon.7c9fd027.svg";